<div class="dropdown">
  <!-- Trigger button with custom icon -->
  <button 
    class="btn btn-outline-secondary dropdown-toggle p-0 m-0 border-0" 
    type="button" 
    id="profileDropdown" 
    data-bs-toggle="dropdown" 
    aria-expanded="false"
  >
    <img 
      src="assets/images/icon_user.png" 
      alt="User Profile Icon" 
      class="profile-icon"
    />
  </button>

  <!-- Dropdown menu -->
  <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="profileDropdown">
    <li>
      <button class="dropdown-item" (click)="logout()">Log Out<br>
      <span class="username">{{ (user$ | async) ?? '' }}</span></button>
    </li>
    <!-- Conditionally display Chat link -->
    <li *ngIf="showChatLink">
      <a class="dropdown-item" href="/galaxy/chat">
        SWIRL AI Assistant
      </a>
    </li>
    <!-- <li>
      <button class="dropdown-item" (click)="toggleTheme()">Switch to {{ mode }} Mode</button>
    </li> -->
    <li *ngIf="isSuperuser">
      <a class="dropdown-item" [href]="swirlAdminLink" target="_blank">
        Manage SWIRL
      </a>
    </li>

    <li>
      <button class="dropdown-item" (click)="toggleCharts()">
        {{ isEnabledCharts ? 'Disable charts' : 'Enable charts' }}
      </button>
    </li>

    <!-- Authenticators Section -->
    <li *ngIf="authenticators.length > 0" class="dropdown-divider"></li>
      <li *ngIf="authenticators.length > 0 && bulkOAuth2Enabled" class="px-3 py-2">
        <button
          class="btn btn-sm w-100"
          [ngClass]="allConnected ? 'btn-outline-danger' : 'btn-primary'"
          (click)="allConnected ? disconnectAll() : startBulkConnect()"
        >
          {{ allConnected ? 'Disconnect All' : 'Connect All' }}
        </button>
      </li>
    <li *ngFor="let a of authenticators">
      <div class="dropdown-item d-flex align-items-center justify-content-between">
        <label class="form-check-label authenticator-label mb-0">
          {{ a.name }}
        </label>
        <div class="form-check form-switch custom-toggle authenticator-toggle">
          <input 
            class="form-check-input"
            type="checkbox"
            [checked]="!a.expired"
            (change)="toggleChange($event, a.idp, a.name, a.expired)"
          />
        </div>
      </div>
    </li>
  </ul>
</div>
